module.exports = __webpack_public_path__ + "media/application/images/2020/redesign2020-header-search-7a8d4ee08eb1815ffdba547543a74dfd.svg";